import { Component, OnInit, SecurityContext } from '@angular/core';
import { AppService } from '../app.service';
import { settings } from "../settings";
import { ModalComponent } from '../modal/modal.component';
import { ColDef, GridApi, GridOptions, MenuItemDef, SideBarDef, IDetailCellRendererParams, GetContextMenuItemsParams, GridReadyEvent } from '@ag-grid-community/core';
import { MatDialog } from '@angular/material/dialog';
import { DoclinkCellRenderer } from '../doclink-cell-renderer/doclink-cell-renderer.component';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-notifications',
  templateUrl: './notificationgrid.component.html',
  styleUrls: ['./notificationgrid.component.css']
})
export class ContactgridComponent {

  title = 'participantdocs';
  mainurl = "";
  defaultColDef = settings.defaultColDef;

  app_gridoptions: GridOptions = settings;
  groupDefaultExpanded = 1;
  columnDefs: ColDef[] = [
    

    { field: 'ecrm_program', headerName: "Program", filter: 'agSetColumnFilter' },
    { field: 'ecrm_contact', headerName: "Participant Name", filter: 'agSetColumnFilter' },
    
    { field: 'ecrm_psid', headerName: "IIE Participant ID", filter: 'agSetColumnFilter' },
    { field: 'ecrm_notificationtype', headerName: "Notification Type", filter: 'agSetColumnFilter' },
    { field: 'ecrm_regarding', headerName: "Regarding", filter: 'agSetColumnFilter' },
    { field: 'ecrm_typeofchange', headerName: "Type of Change", filter: 'agSetColumnFilter' },
    { field: 'ecrm_oldvalue', headerName: "Old Value", filter: 'agSetColumnFilter' },
    { field: 'ecrm_newvalue', headerName: "New Value", filter: 'agSetColumnFilter' },
    { field: 'ecrm_modifiedon', headerName: "Modified On", filter: 'agSetColumnFilter' },
    { field: 'ecrm_partnerowner', headerName: "Partner Owner", filter: 'agSetColumnFilter' },
    

  ];
  rowData: any[] = [];

  // loadingCellRenderer: any = CustomLoadingCellRenderer;
  loadingCellRendererParams: any = {
    loadingMessage: 'Loading please wait...',
  };

  sideBar: SideBarDef = {
    toolPanels: ['columns', 'filters']

  }



  constructor(private service: AppService, private dialog: MatDialog, private sanitizer: DomSanitizer) {

  }

  ngOnInit(): void {
    this.mainurl = window.origin;

  }

  getContextMenuItems = (params: GetContextMenuItemsParams) => {

    let result = [
      {
        name: "Open",
        action: () => {
          let notifId = params.node?.data.notificationId;
          let url = this.mainurl + "/partner-portals/notifications/details?id=" + notifId;
          // window.open(url, "_self");
          this.menuAction("Notification", url);

        },
      },
      'copy',
      'export'
    ]

    return result;
  }


  onGridReady = (params: GridReadyEvent<any>) => {

    let url = parent.window.location.href;
    

    params.api.showLoadingOverlay();

    params.api?.setColumnDefs(this.columnDefs);

    this.service.getNotifications().subscribe(result => {

      params.api.hideOverlay();
      console.log(result);
      this.rowData = result;
      this.app_gridoptions.api?.setColumnDefs(this.columnDefs);
      this.app_gridoptions.api?.sizeColumnsToFit();
      this.app_gridoptions.api?.setRowData(this.rowData);
      


    }, error => {
      console.log(error);
      params.api.hideOverlay();
    })

  }


  menuAction(windowtitle: any, url: any) {

    // const filterSettings = this.app_gridoptions.api?.getFilterModel();
    // localStorage.setItem('gridParticipantDocsFilterSettings', JSON.stringify(filterSettings));

    windowtitle = windowtitle || "Notification";
    const urlsafe = this.sanitizer.bypassSecurityTrustResourceUrl(url);
    this.dialog.open(ModalComponent, { data: { title: windowtitle, url: urlsafe }, disableClose: true, width: '90%', maxWidth: '860px' })

  }


  // Define the event handler function
  handleFilterChanged = () => {

    // Get the current filter model
    const filterSettings = this.app_gridoptions.api?.getFilterModel();

    // Save the filter settings to localStorage
    localStorage.setItem('gridParticipantDocsFilterSettings', JSON.stringify(filterSettings));

    // You can also perform any other actions you need with the filter settings here
  };

}